
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/event/[hashedeventId]",
      function () {
        return require("private-next-pages/event/[hashedeventId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/event/[hashedeventId]"])
      });
    }
  